import { Spin } from "antd";
import { useEffect, useState } from "react";
import { AppProviders } from "./providers/AppProviders";
import { AppRoutes } from "./routes/AppRoutes";
import { useAuthStore } from "../stores/authStore";
import { UniversalRightLookupPanel } from "../shared/lookup/UniversalRightLookupPanel";
import { EntityFormLauncherHost } from "../shared/entityForms/EntityFormLauncherHost";

function Bootstrapper() {
  const { setHydrated, hydrated } = useAuthStore();
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    let active = true;
    queueMicrotask(() => {
      if (!active) return;
      setHydrated(true);
      if (active) setBooting(false);
    });
    return () => { active = false; };
  }, [setHydrated]);

  if (booting && !hydrated) {
    return <div className="boot-screen"><Spin><span>Loading accounting workspace...</span></Spin></div>;
  }

  return (
    <>
      <AppRoutes />
      <UniversalRightLookupPanel />
      <EntityFormLauncherHost />
    </>
  );
}

export function App() {
  return (
    <AppProviders>
      <Bootstrapper />
    </AppProviders>
  );
}
